import React, { useState, useRef, useEffect } from "react";
import { Tabs } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import six from "../../assets/6.png";
import Vector2 from "../../assets/Vector2.png";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import Steps from "./Steps";
import { fetchCategories } from "../../redux/categoriesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;

const ServicesSection = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [activeTab, setActiveTab] = useState("0");
  const [visibleStart, setVisibleStart] = useState(0);
  const swiperRef = useRef(null);

  const dispatch = useDispatch();
  const { categories, status, error } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategories());
    }
  }, [status, dispatch]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    swiperRef.current.slideTo(Number(key));
  };

  const handleSlideChange = (swiper) => {
    setActiveTab(String(swiper.activeIndex));
    setVisibleStart(Math.max(swiper.activeIndex - 2, 0));
  };

  const handlePrev = () => {
    if (visibleStart > 0) {
      setVisibleStart(visibleStart - 1);
    }
  };

  const handleNext = () => {
    if (visibleStart + 5 < categories.length) {
      setVisibleStart(visibleStart + 1);
    }
  };

  return (
    <div className="my-20 max-lg:my-5 px-20 max-lg:px-5 relative ServicesSection">
      <h2 className="text-[#14294F] text-3xl font-semibold">
        {t("Services_Overview")}
      </h2>
      <p className="text-[#737E91] text-lg mt-3 mb-5">
        {t("mainServices.learnOurServices")}
      </p>

      {status === "loading" ? (
        <p>Loading categories...</p>
      ) : status === "failed" ? (
        <p>Error loading categories: {error}</p>
      ) : (
        <div className="flex items-center" dir="ltr">
          {/* Left Arrow */}
          <div className="bg-[#FE9B71] text-white pt-3 pb-2 px-3 rounded-full">
            <LeftOutlined
              onClick={handlePrev}
              className={`text-xl ${
                visibleStart === 0 ? "opacity-50" : "cursor-pointer"
              }`}
            />
          </div>

          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="overflow-hidden flex-1"
          >
            {categories
              .slice(visibleStart, visibleStart + 5)
              .map((category, index) => (
                <TabPane
                  key={visibleStart + index}
                  tab={
                    <div
                      className={`bg-white rounded-full w-[100px] h-[100px] max-lg:w-[80px] max-lg:h-[80px] flex items-center p-4 ${
                        activeTab === String(visibleStart + index)
                          ? "border-4 border-[#FE9B71]"
                          : ""
                      }`}
                      style={{ boxShadow: "0px 2px 10px 6px #c3c3c326" }}
                    >
                      <img
                        src={`https://service.samoolah.com/${category.icon}`}
                        className="mx-auto"
                        width="50px"
                        alt={category.name_en}
                      />
                    </div>
                  }
                />
              ))}
          </Tabs>

          {/* Right Arrow */}
          <div className="bg-[#FE9B71] text-white pt-3 pb-2 px-3 rounded-full">
            <RightOutlined
              onClick={handleNext}
              className={`text-xl ${
                visibleStart + 5 >= categories.length
                  ? "opacity-50"
                  : "cursor-pointer"
              }`}
            />
          </div>
        </div>
      )}

      {/* Swiper for Sliding Content */}
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true }}
        onSlideChange={handleSlideChange}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {categories.map((category, index) => (
          <SwiperSlide key={index} className="relative mr-0" style={{marginRight: "0px", marginLeft: "0px"}} dir="ltr">
            <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 px-14 max-lg:px-5 mt-10" dir={language == "en" ? "ltr" : "rtl"}>
              <div className="lg:col-span-2">
                <h3 className="text-[#283D63] text-2xl font-semibold">
                  {language === "en" ? category.name_en : category.name}
                </h3>
                <p className="text-[#737E91] text-lg mt-3">
                  {language === "en" ? category.desc_en : category.desc}
                </p>
              </div>
              <div>
                <img
                  src={`https://service.samoolah.com/${category.icon}`}
                  className="w-[160px] flex justify-center mx-auto"
                />
              </div>
            </div>
            <img
              src={Vector2}
              className="w-[300px] absolute left-20 top-60 z-10 max-lg:hidden"
            />
            <div className="flex justify-center items-center text-center mt-14">
              <Link
                to={`/services/${category.id}`}
                className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] w-[250px] h-[55px] text-xl flex items-center justify-center font-semibold flex justify-center mx-auto"
              >
                {t("Book Service")}
              </Link>
            </div>
            <div className="mt-56 max-lg:mt-20 max-lg:hidden" dir={language == "en" ? "ltr" : "rtl"}>
              <Steps />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ServicesSection;
